/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CaretDwn from './CaretDwn.svg';
import CaretFwd from './CaretFwd.svg';
import style from './style.module.css';

const DropTable = ({ rows, children }) => {
  const metaDataMissing = !rows || !rows[0] || !rows[0].levels
    || !rows[0].descendants || !rows[0].parents;

  if (metaDataMissing) {
    return null;
  }

  const [{ descendants, levels, parents }, ...data] = rows;
  const [isExpanded, setIsExpanded] = useState(levels.map(l => 0));
  const [isVisible, setIsVisible] = useState(levels.map(l => ((l === 0) ? 1 : 0)));
  const [active, setActive] = useState(null);
  const hasChildren = data.map((d, didx) => ((parents.indexOf(didx) !== -1) ? 1 : 0));

  const toggleActiveColor = (idx) => {
    const nodeIsActiveButNotExpanded = idx === active && isExpanded[idx];
    setActive(nodeIsActiveButNotExpanded ? null : idx);
  };

  const toggleExpansion = (idx) => {
    isExpanded[idx] = !isExpanded[idx] ? 1 : 0;
    setIsExpanded([...isExpanded]);
  };

  const toggleDescendantVisiblity = (idx) => {
    descendants[idx].forEach((aidx) => {
      const selectedRow = idx;
      const affectedRowIsDirectChildOfSelectedRow = parents[aidx] === selectedRow;
      const parentOfAffectedRow = parents[aidx];
      const parentRowIsExpanded = isExpanded[parentOfAffectedRow];
      const selectedRowIsExpanded = isExpanded[idx];

      if (affectedRowIsDirectChildOfSelectedRow) {
        isVisible[aidx] = !isVisible[aidx] ? 1 : 0;
        return;
      }

      if (parentRowIsExpanded && selectedRowIsExpanded) {
        isVisible[aidx] = 1;
      }

      if (!parentRowIsExpanded) {
        isVisible[aidx] = 0;
      }

      if (!selectedRowIsExpanded) {
        isVisible[aidx] = 0;
      }
    });

    const visibleRows = isVisible.map((v, vidx) => {
      const currRowParent = parents[vidx];
      // root items are always visible
      if (currRowParent === -1) {
        return 1;
      }
      // if parent is not expanded then do not show this row
      if (!isExpanded[currRowParent]) {
        return 0;
      }
      // else return given value
      return v;
    });

    setIsVisible([...visibleRows]);
  };

  const toggleStates = idx => () => {
    toggleActiveColor(idx);
    toggleExpansion(idx);
    toggleDescendantVisiblity(idx);
  };

  return (
    <table className={style.dropTable}>
      <thead>
        {children && children}
      </thead>
      <tbody>
        {
          data.map((row, rowIdx) => (
            <tr
              className={active === rowIdx ? style.active : ''}
              style={{
                display: isVisible[rowIdx] ? '' : 'none',
              }}
            >
              {row.map((r, idx) => (
                (idx !== 0) ?
                  <td>{r}</td> :
                  (
                    <td
                      onClick={toggleStates(rowIdx)}
                      style={{
                        paddingLeft: 15 * levels[rowIdx],
                      }}
                    >
                      {
                        hasChildren[rowIdx] === 1 &&
                        <img
                          alt="toggle-icon"
                          className={style.icon}
                          src={isExpanded[rowIdx] ? CaretDwn : CaretFwd}
                        />
                      }
                      {r}
                    </td>
                  )
              ))}
            </tr>
          ))
        }
      </tbody>
    </table>
  );
};

DropTable.propTypes = {
  rows: PropTypes.array,
  children: PropTypes.children,
};

export default DropTable;
